// ─── TruckerCloud Compatibility Lists ────────────────────────────────────────

export const TC_CAMERAS = [
  'Lytx', 'Motive', 'Netradyne', 'Samsara', 'Surfsight',
  'Driver Technologies', 'FleetHunt', 'SmartDrive',
  'Verizon Connect', 'IntelliShift', 'Eye Ride',
  'Lightmetrics', 'Raven', 'Azuga', 'Forward Thinking Systems',
  'GPS Web Pro', 'TXT Camera', 'RoadEazy',
];

export const TC_ELDS = [
  '888 ELD', 'ABC', 'Action ELD', 'AFSWorld',
  'Affordable GPS Tracking', 'Air ELD', 'AMPM ELD',
  'Apollo ELD', 'AT&T Fleet Management', 'Azuga',
  'BigRoad', 'Black Bear ELD', 'Blue Sun ELD', 'BlueInk',
  'Captain ELD', 'Chronos ELD', 'Clearpath GPS',
  'Columbus ELD', 'Daily ELD Plus', 'DLOG ELD',
  'Digital ELD', 'DriverTech', 'DSGELOGS', 'Dy+ ELD',
  'Eco Track', 'EGreen ELD', 'ELDDesired', 'ELDMandateHOS',
  'ELDTREX', 'EliteGPS', 'EROAD', 'Eva ELD', 'Eye Ride',
  'Factor ELD', 'FleetComplete', 'FordPro',
  'Forward Thinking Systems Intellihub', 'Fuel Express',
  'GeoTab', 'GeoTab ATT', 'GPSTab', 'GPSTrackit', 'GPS INSIGHT',
  'Hero ELD', 'HOS247', 'iLog ELD', 'Intellishift', 'ISAAC',
  'Just ELD', 'J. J. Keller', 'Knight ELD',
  'Lancer Auto Group', 'LBTechnology', 'Leader ELD',
  'Legacy ELD', 'Light & Travel ELD', 'Linxup', 'Lioneight',
  'Live View GPS', 'Loop ELD', 'Lucid ELD', 'Maestral ELD',
  'Max ELD', 'Mobile Tracking', 'Moonlight ELD',
  'Monarch Tracking', 'Motive', 'My Logs', 'Nero',
  'Next Fleet ELD', 'Nuvo Solutions', 'Omnitracs ES',
  'OmnitracsXRS', 'OneStepGPS', 'Onroad ELD', 'Optima ELD',
  'Orbcomm', 'Panda ELD', 'Patriot ELD', 'Peak ELD',
  'Pedigree', 'PeopleNet', 'Phoenix ELD', 'Pop ELD',
  'Prestige ELD', 'Pro ride ELD', 'Prologs',
  'Quality Logs ELD', 'Responsible Fleet GPS',
  'Robinhood ELD', 'Rock ELD', 'Routemate ELD', 'Spireon',
  'Secure Path ELD', 'Sharp ELD', 'Simplex', 'Sparkle ELD',
  'S13 ELD', 'Samsara', 'Smart ELDs', 'STATE ELOGS',
  'Startrucks ELD', 'SUPPORT ELD', 'Swift ELD',
  'Teletrac Navman', '3MD ELD', 'Touch Tel GPS',
  'TOP COMPLIANCE ELD', 'TrackEnsure',
  'Transcor Data Services', 'Transflo', 'Transit ELD',
  'TruckX', 'TRUST ELD', 'TxELD', 'TXT ELD', 'US Power ELD',
  'UZB Prime ELD', 'Verizon Connect', 'Vitality ELD',
  'Vestige', 'Vlog ELD', 'Vulcansols', 'Webfleet Solutions',
  'WEX Telematics', 'X ELD', 'Xpert Logs', 'Xplore ELD',
  'Zero Max ELD', 'Zonar', 'Zubie',
];

// Fuzzy match: case-insensitive, checks if query is substring of any list entry
// or any list entry is a substring of query (handles "Samsara ELD" matching "Samsara")
export function tcMatch(query, list) {
  if (!query || !query.trim()) return null; // unknown
  const q = query.trim().toLowerCase();
  return list.some(item => {
    const i = item.toLowerCase();
    return i.includes(q) || q.includes(i);
  });
}

// Returns 'yes' | 'no' | 'unknown'
export function tcEldStatus(brand)     { const m = tcMatch(brand, TC_ELDS);    return m === null ? 'unknown' : m ? 'yes' : 'no'; }
export function tcCamStatus(brand)     { const m = tcMatch(brand, TC_CAMERAS); return m === null ? 'unknown' : m ? 'yes' : 'no'; }

// Overall status from two individual statuses
export function tcOverallStatus(eldStatus, camStatus) {
  if (eldStatus === 'unknown' && camStatus === 'unknown') return 'unknown';
  if (eldStatus === 'yes' && camStatus === 'yes')         return 'both';
  if (eldStatus === 'yes' || camStatus === 'yes')         return 'partial';
  return 'none';
}

// AI context string
export function tcAIContext(eldBrand, dashcamBrand) {
  const lines = [];
  if (eldBrand) {
    const s = tcEldStatus(eldBrand);
    if (s === 'yes')
      lines.push(`Carrier uses ${eldBrand} ELD which is TruckerCloud compatible — may qualify for preferred pricing with markets that accept TruckerCloud telematics connections.`);
    else if (s === 'no')
      lines.push(`Carrier uses ${eldBrand} ELD which is not currently listed as TruckerCloud compatible — agent should verify telematics requirements with target markets.`);
  }
  if (dashcamBrand) {
    const s = tcCamStatus(dashcamBrand);
    if (s === 'yes')
      lines.push(`Carrier uses ${dashcamBrand} dashcam which is TruckerCloud compatible.`);
    else if (s === 'no')
      lines.push(`Carrier uses ${dashcamBrand} dashcam which is not currently listed as TruckerCloud compatible.`);
  }
  return lines.join('\n');
}
